export { default as GraphQLWrapper } from './core/GraphQLWrapper';
import ConnectorTheGraph from './connector';
export default ConnectorTheGraph;
export * from './types';
